/* ========================================
   Custom Section — Full Width Video
   Full-width autoplay video with optional title
   ======================================== */

window.sectionRenderers = window.sectionRenderers || {};

window.sectionRenderers.fullWidthVideo = function(data) {
  if (!data.videoUrl) return '';
  return '<div class="cs-full-width">' +
    '<div class="cs-full-width__media">' +
      '<video src="' + escapeHtml(data.videoUrl) + '" loop muted playsinline preload="metadata"></video>' +
      '<div class="cs-full-width__play" onclick="toggleCsVideo(this)"><svg class="cs-play-icon" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg><svg class="cs-pause-icon" viewBox="0 0 24 24" fill="white" style="display:none"><rect x="5" y="3" width="4" height="18"/><rect x="15" y="3" width="4" height="18"/></svg></div>' +
      (data.title ? '<h3 class="cs-full-width__title">' + escapeHtml(data.title) + '</h3>' : '') +
    '</div>' +
  '</div>';
};

function toggleCsVideo(button) {
  const media = button.closest('.cs-full-width__media') || button.closest('.cs-media-text__media');
  if (!media) return;
  const video = media.querySelector('video');
  if (!video) return;
  const playIcon = button.querySelector('.cs-play-icon');
  const pauseIcon = button.querySelector('.cs-pause-icon');
  if (video.paused) {
    video.play();
    media.classList.add(media.classList.contains('cs-full-width__media') ? 'cs-full-width__media--playing' : 'cs-media-text__media--playing');
    if (playIcon) playIcon.style.display = 'none';
    if (pauseIcon) pauseIcon.style.display = 'block';
  } else {
    video.pause();
    media.classList.remove('cs-full-width__media--playing', 'cs-media-text__media--playing');
    if (playIcon) playIcon.style.display = 'block';
    if (pauseIcon) pauseIcon.style.display = 'none';
  }
}
